<template>
    <div class="diseaseBank-ditails">
        <!--      <diseaseBank-ditails-skeleton v-if="loading"></diseaseBank-ditails-skeleton>-->

        <!--      <div v-else>-->
        <div class="diseaseBank-ditails-section">
            <van-row class="diseaseBank-ditails-section-box">
                <div class="diseaseBank-ditails-title">{{ detail.title }}</div>
                <div class="diseaseBank-ditails-content-desc" v-html="detail.desc"></div>
                <div class="diseaseBank-ditails-line"></div>
                <van-grid column-num="5" :border="false">
                    <template v-for="(item, index) in detail.knowledge_part">
                        <van-grid-item
                            v-if="index < 4"
                            :key="index"
                            :icon="item.cover_img"
                            :text="item.title"
                            @click="
                                $router.push({ name: 'knowledge-detail', params: { id: id }, query: { part: index } })
                            "
                        />
                    </template>

                    <van-grid-item
                        v-if="detail.knowledge_part && detail.knowledge_part.length > 4"
                        icon="/static/bytx/knowledge_illness_7_icon.svg"
                        text="更多"
                        @click="$router.push({ name: 'knowledge-detail', params: { id: id }, query: { part: 0 } })"
                    />
                </van-grid>
                <!--  -->

                <div class="clear"></div>
                <div class="diseaseBank-ditails-line" v-if="detail.teacher_avatar != ''"></div>
                <div class="diseaseBank-ditails-doctor" v-if="detail.teacher_avatar !== ''">
                    <div class="diseaseBank-ditails-doctor-title">审核专家{{ detail.audit_professor }}</div>
                    <div class="diseaseBank-ditails-doctor-avatar"><img :src="detail.teacher_avatar" alt="" /></div>
                    <div class="diseaseBank-ditails-doctor-box">
                        <div class="diseaseBank-ditails-doctor-name">{{ detail.audit_professor }}</div>
                        <div class="diseaseBank-ditails-doctor-intro">{{ detail.teacher }}</div>
                    </div>
                    <div class="clear"></div>
                </div>
            </van-row>
        </div>

        <div class="disease-details-quick-entry">
            <van-grid
                column-num="4"
                class="disease-details-quick-main"
                active-color="#404040"
                v-model="active"
                :fixed="false"
                :border="false"
            >
                <van-grid-item @click="goList('welfare-zone', '公益救助', 6)">
                    <van-image src="/static/bytx/anticancer/homebanner-1.svg" />
                    <span>咨询医生</span>
                </van-grid-item>
                <van-grid-item @click="goList('activity-list', '近期活动', 3)">
                    <van-image src="/static/bytx/anticancer/homebanner-2.svg" />
                    <span>在线开药</span>
                </van-grid-item>
                <van-grid-item @click="goGuide()">
                    <van-image src="/static/bytx/anticancer/homebanner-3.svg" />
                    <span>临床招募</span>
                </van-grid-item>
                <van-grid-item @click="goList('clinic-list', '近期活动', 5)">
                    <van-image src="/static/bytx/anticancer/homebanner-4.svg" />
                    <span>救助项目</span>
                </van-grid-item>
            </van-grid>
        </div>

        <div class="tags" style="margin-top: 30px">
            <van-tabs :swipeable="true" v-model="category_index">
                <van-tab
                    :title-class="'course-list-category-title'"
                    v-for="(item, index) in categories"
                    :key="index"
                    :title="item.name"
                ></van-tab>
            </van-tabs>
            <div class="clear"></div>
        </div>

        <wx-open-launch-weapp
            :username="appid"
            :path="doctor_path"
            style="width:58px;height:58px;position: fixed;bottom: 120px;right: 15px;z-index: 999"
        >
            <script type="text/wxtag-template">
                <img width="100%" src="https://bytx.care-gobroad.com/static/bytx/detail_expert_btn.svg" alt="">
            </script>
        </wx-open-launch-weapp>

        <div v-if="category_index === 0 && recommend.lives && recommend.lives.length >= 0" style="margin-top: 20px;">
            <div class="live-list-section">
                <van-row @click="go_live_detail(item)" v-for="item in recommend.lives" :key="item.id">
                    <div class="live-list-section-box">
                        <div class="live-list-section-left">
                            <van-image class="live-list-section-left-img" fit="cover" :src="item.cover_img" />
                            <div v-if="item.type == 2" class="live-list-section-left-zl">
                                直播专题
                            </div>
                            <div v-else-if="item.live_status == 0" class="live-list-section-left-zl">直播预告</div>
                            <div v-else-if="item.live_status == 1" class="live-list-section-left-zl">
                                <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> 直播中
                            </div>
                            <div v-else class="live-list-section-left-zl">
                                直播回放
                            </div>
                        </div>
                        <div class="live-list-section-right">
                            <div class="live-list-section-right-title">{{ item.title }}</div>
                            <div class="live-list-section-right-detail" style="bottom: 25px" v-if="item.type == 2">
                                已开展{{ item.current_count }}期
                            </div>
                            <div class="live-list-section-right-detail" v-else>
                                {{ item.start_at }}
                                <span class="live-list-section-right-detail-join">
                                    {{ item.live_status === 0 ? (item.isAppointment ? '已预约' : '预约') : '加入' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </van-row>
            </div>
            <van-empty v-if="recommend.lives.length === 0" description="" image="/static/img/pic_blank_content.svg">
                <template slot="description">
                    <div style="text-align: center">博医同行持续更新中…</div>
                    <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                    <div style="text-align: center;margin-top: 24px">
                        <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                            返回首页
                        </van-button>
                    </div>
                </template>
            </van-empty>
        </div>

        <template v-for="item in recommend.articles">
            <div
                class="home-section-box"
                v-if="category_index === 1 && recommend.articles && recommend.articles.length >= 0"
                :key="item.id"
            >
                <div v-if="item.content_type === 2" class="article-list-section">
                    <van-row class="article-list-section-box" @click="goArticle(item)">
                        <van-col span="8">
                            <van-image
                                fit="cover"
                                class="article-list-content-img"
                                :src="item.cover_img"
                                width="100%"
                                height="74"
                            />
                            <div class="community-list-section-left-zl" v-if="item.type == 2">
                                图文专题
                            </div>
                        </van-col>
                        <van-col span="16" class="article-list-content">
                            <div class="article-list-title">
                                {{ item.title.length > 34 ? item.title.substr(0, 34) + '...' : item.title }}
                            </div>
                            <div class="article-list-content-detail">
                                <div>
                                    {{ item.created_at }}
                                    <span style="margin-left: 8px">{{ item.view_count }}人阅读</span>
                                </div>
                            </div>
                        </van-col>
                    </van-row>
                </div>

                <div v-if="item.content_type === 7" class="clinic-list-section" style="padding-bottom: 0">
                    <van-row
                        class="clinic-list-section-box"
                        @click="$router.push({ name: 'clinic-detail', params: { id: item.id } })"
                    >
                        <div class="clinic-list-title">
                            <span>临床招募</span>
                            {{ item.title.length > 34 ? item.title.substr(0, 34) + '...' : item.title }}
                        </div>
                        <div class="clinic-list-desc">
                            {{ item.desc.length > 26 ? item.desc.substr(0, 26) + '...' : item.desc }}
                        </div>
                        <div class="clinic-list-tags">
                            <span v-for="(val, valIndex) in item.tags.split(',')" :key="valIndex">#{{ val }}</span>
                        </div>
                    </van-row>
                </div>

                <div v-if="item.content_type === 8" class="community-list-section">
                    <van-row
                        class="community-list-section-box"
                        @click="$router.push({ name: 'community-detail', params: { id: item.id } })"
                    >
                        <div class="community-list-section-left">
                            <van-image
                                fit="cover"
                                class="community-list-section-left-img"
                                :src="item.cover_img"
                                width="100%"
                                height="100%"
                            />
                            <div class="community-list-section-left-zl">
                                公益救助
                            </div>
                        </div>
                        <div class="community-list-section-right">
                            <div class="community-list-section-right-title">{{ item.title }}</div>
                            <div class="community-list-section-right-detail">
                                <div>
                                    {{ item.created_at }}
                                    <span style="margin-left: 8px">{{ item.view_count }}人阅读</span>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </van-row>
                </div>

                <div v-if="item.content_type === 11" class="diagnose-list-section">
                    <van-row
                        class="diagnose-list-section-box"
                        @click="$router.push({ name: 'diagnose-detail', params: { id: item.id } })"
                    >
                        <div class="diagnose-list-section-left">
                            <van-image
                                fit="cover"
                                class="diagnose-list-section-left-img"
                                :src="item.cover_img"
                                width="100%"
                                height="100%"
                            />
                            <div class="diagnose-list-section-left-zl">
                                诊断送检
                            </div>
                        </div>
                        <div class="diagnose-list-section-right">
                            <div class="diagnose-list-section-right-title">{{ item.title }}</div>
                            <div class="diagnose-list-section-right-btn">
                                去查看 <img src="/static/bytx/list_more_icon.svg" alt="" />
                            </div>
                        </div>
                        <div class="clear"></div>
                        <div class="diagnose-list-section-info">{{ item.desc }}</div>
                    </van-row>
                </div>

                <van-empty
                    v-if="recommend.articles.length === 0"
                    description=""
                    image="/static/img/pic_blank_content.svg"
                >
                    <template slot="description">
                        <div style="text-align: center">博医同行持续更新中…</div>
                        <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                        <div style="text-align: center;margin-top: 24px">
                            <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                                返回首页
                            </van-button>
                        </div>
                    </template>
                </van-empty>
            </div>
        </template>
        <div
            v-if="category_index === 2 && recommend.videos && recommend.videos.length >= 0"
            class="course-list-section"
            style="margin-top: 22px"
        >
            <van-row @click="go_video_detail(item)" v-for="item in recommend.videos" :key="item.id">
                <div class="course-list-section-box">
                    <div class="course-list-section-left">
                        <van-image
                            fit="cover"
                            class="course-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="72"
                        />
                        <div v-if="item.type == 2" class="course-list-section-left-zl">
                            视频专栏
                        </div>
                        <div class="course-list-section-left-zl" v-else>
                            精彩视频
                        </div>
                    </div>
                    <div class="course-list-section-right">
                        <div class="course-list-section-right-title">{{ item.title }}</div>
                        <div class="course-list-section-right-detail" v-if="item.type == 2">
                            已更新{{ item.current_count }}节 | 共{{ item.total_count }}节
                        </div>
                        <div class="course-list-section-right-detail" v-else>{{ item.view_count }}人学习</div>
                    </div>
                </div>
            </van-row>
            <van-empty v-if="recommend.videos.length === 0" description="" image="/static/img/pic_blank_content.svg">
                <template slot="description">
                    <!--<div style="text-align: center">已到底部</div>-->
                    <div style="text-align: center">博医同行持续更新中…</div>
                    <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                    <div style="text-align: center;margin-top: 24px">
                        <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                            返回首页
                        </van-button>
                    </div>
                </template>
            </van-empty>
        </div>
        <div v-if="category_index === 3 && recommend.manual" class="manual-details-item">
            <van-row @click="go_video_detail(item)" v-for="item in recommend.manual" :key="item.id">
                <div class="manual-details">
                    <div class="manual-details-left">
                        <van-image src="/static/bytx/anticancer/manual_banner.png" />
                    </div>
                    <div class="manual-details-right">
                        <span class="title">治疗癌症手册</span>
                        <div class="content-text">
                            早期预防癌症最重要重视 12 个“呼救信号”， 有些肿瘤很难早期发现,80%以上的癌症患者被确诊
                            时已经到了中晚期。
                        </div>

                        <div class="manual-details-right-footer">
                            <div class="apply">
                                <van-image src="/static/bytx/anticancer/apply.svg" />
                                申请手册
                            </div>
                            <van-button round plain class="read-btn" type="primary" color="#03CBBF" size="mini"
                                >在线阅读
                            </van-button>
                        </div>
                    </div>
                </div>
            </van-row>
            <van-empty v-if="recommend.manual.length === 0" description="" image="/static/img/pic_blank_content.svg">
                <template slot="description">
                    <div style="text-align: center">博医同行持续更新中…</div>
                    <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                    <div style="text-align: center;margin-top: 24px">
                        <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                            返回首页
                        </van-button>
                    </div>
                </template>
            </van-empty>
        </div>

        <van-dialog class="feedback" v-model="openFeedback" :showConfirmButton="false">
            <template slot="title">
                <div class="close-pop" @click="openFeedback = false">
                    <img src="/static/bytx/popup_close_icon.svg" alt="" />
                </div>
                <h3>学知识反馈</h3>
            </template>

            <div class="clear"></div>

            <div>战友您好，请您长按识别下方二维码添加小助手，反馈您的意见与建议，博医同行将因您变得更好。</div>

            <div align="center">
                <img src="/static/bytx/kefu.svg" alt="" />
            </div>
        </van-dialog>

        <div class="diseaseBank-ditails-footer">
            <div class="diseaseBank-ditails-footer-box">
                <div style="width: 100%">
                    <van-grid direction="horizontal" :column-num="3" :border="false">
                        <van-grid-item
                            @click="favorite()"
                            v-if="detail.isFavorite"
                            icon="/static/img/course/icon_course_favorite_on_20.svg"
                            text="已收藏"
                        />
                        <van-grid-item
                            @click="favorite()"
                            v-else
                            icon="/static/img/course/icon_course_favorite_off_20.svg"
                            text="收藏"
                        />
                        <van-grid-item
                            @click="pointLike()"
                            v-if="detail.isLike"
                            icon="/static/img/course/icon_course_like_on.svg"
                            text="有帮助"
                            :badge="detail.like_count"
                        />
                        <van-grid-item
                            @click="pointLike()"
                            v-else
                            icon="/static/img/course/icon_course_like_off.svg"
                            text="有帮助"
                            :badge="detail.like_count"
                        />
                        <van-grid-item
                            @click="goWechat()"
                            icon="/static/bytx/tab_detail_feedback_icon.svg"
                            text="反馈"
                        />
                    </van-grid>
                </div>
            </div>
            <van-number-keyboard safe-area-inset-bottom />
        </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import knowledgeListSkeleton from '@/skeleton/articleListSkeleton'
import {LocationHref} from '@/util/common'

export default {
    name: 'diseaseBank-ditails',
    components: {
        'knowledge-list-skeleton': knowledgeListSkeleton
    },
    data() {
        return {
            appid: 'gh_2af07dce0869',
            doctor_path: 'pages/doctorModule/doctorList/index.html?routerName=expertList',
            detail: {},
            value: '',
            active: '',
            category_id: 0,
            category_child_id: 0,
            category_index: 0,
            banners: [],
            categories: [
                { id: 1, name: '相关直播' },
                { id: 2, name: '相关图文' },
                { id: 3, name: '相关视频' },
                { id: 4, name: '手册' }
            ],
            categories_child: [],
            recommend: {
                videos: [],
                articles: [],
                lives: [],
                manual: []
            },
            list: [],
            column: [],
            loading: true,
            page: 1,
            pageSize: 10,
            total_page: 1,
            items: [{ text: '分组 1' }, { text: '分组 2' }],
            openFeedback: false
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'detail') {
                Interface.getData('get', Interface.knowledge.detail + this.id).then(res => {
                    if (res.code === 0) {
                        this.detail = res.data
                        document.title = res.data.title
                        Interface.getShareInfo(this, '博医同行-' + res.data.title, '', '博医同行,大病患者互助医疗社区')

                        if (res.data.recommends) {
                            if (res.data.recommends.manual && res.data.recommends.manual.length > 0) {
                                this.recommend.manual = res.data.recommends.manual
                                this.category_index = 3
                            }
                            if (res.data.recommends.videos && res.data.recommends.videos.length > 0) {
                                this.recommend.videos = res.data.recommends.videos
                                this.category_index = 2
                            }
                            if (res.data.recommends.articles && res.data.recommends.articles.length > 0) {
                                this.recommend.articles = res.data.recommends.articles
                                this.category_index = 1
                            }
                            if (res.data.recommends.lives && res.data.recommends.lives.length > 0) {
                                this.recommend.lives = res.data.recommends.lives
                                this.category_index = 0
                            }
                        }

                        // console.log(res, this.recommend)
                    }

                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            } else if (scene === 'footprint') {
                let params = {
                    id: this.id,
                    type: 9
                }
                Interface.getData('post', Interface.footprint, params)
            }
        },
        fetch_more() {
            this.page += 1
            let params = {
                page: this.page,
                pageSize: 10,
                category_id: this.category_id
            }
            Interface.getData('get', Interface.knowledge.list, params).then(res => {
                this.list.push(...res.data.list)
                this.total_page = res.data.total_page
            })
        },
        favorite() {
            Interface.getData('get', Interface.knowledge.favorite + this.id).then(res => {
                if (res.code === 0) {
                    this.detail.isFavorite = !this.detail.isFavorite
                    this.$forceUpdate()
                }
            })
        },
        pointLike() {
            Interface.getData('get', Interface.knowledge.like + this.id).then(res => {
                if (res.code == 0) {
                    this.detail.like_count = this.detail.isLike
                        ? parseInt(this.detail.like_count) - 1
                        : parseInt(this.detail.like_count) + 1
                    this.detail.isLike = !this.detail.isLike
                    this.$forceUpdate()
                }
            })
        },
        go_live_detail(item) {
            if (item.type === 2) {
                this.$router.push({ name: 'live-column', params: { id: item.id } })
            } else if (item.live_status === 6) {
                this.$router.push({ name: 'live-detail-home', params: { id: item.id } })
            } else {
                if (item.live_status === 0) {
                    this.$router.push({ name: 'live-detail', params: { id: item.id } })
                } else {
                    this.$router.push({ name: 'live-detail-home', params: { id: item.id } })
                }
            }
        },
        goWechat() {
            LocationHref('https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8')
        },
        go_video_detail(item) {
            if (item.type === 2) {
                this.$router.push({ name: 'video-column', params: { id: item.id } })
            } else {
                this.$router.push({ name: 'video-detail', params: { id: item.id } })
            }
        },
        goArticle(item) {
            if (item.type === 2) {
                this.$router.push({ name: 'article-column', params: { id: item.id } })
            } else {
                this.$router.push({ name: 'article-detail', params: { id: item.id } })
            }
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch('detail')
        this.fetch('footprint')
        sessionStorage.removeItem('search_data')
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/anticancer/diseaseBank/details/index.vue